import state from '@/store/auth/state'
import getters from '@/store/auth/getters'
import mutations from '@/store/auth/mutations'
import actions from '@/store/auth/actions'

export default {
  state,
  getters,
  mutations,
  actions,
}
